import { render, staticRenderFns } from "./TucowsPromoListComponent.vue?vue&type=template&id=e9909d6a"
import script from "./TucowsPromoListComponent.vue?vue&type=script&lang=js"
export * from "./TucowsPromoListComponent.vue?vue&type=script&lang=js"
import style0 from "./TucowsPromoListComponent.vue?vue&type=style&index=0&id=e9909d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports